import { Rect } from '../primitives/rect';
import { cloneObject } from '../utility/base-util';
export class GraphForceNode {
    constructor(gnNode) {
        /**
         * @private
         */
        this.velocityX = 0;
        /**
         * @private
         */
        this.velocityY = 0;
        /**
         * @private
         */
        this.nodes = [];
        this.graphNode = gnNode;
        const nNode = this.graphNode;
        const bounds = getGraphBounds(nNode);
        this.location = bounds.center;
        this.nodes = [];
        if (!gnNode.treeInfo.parents) {
            gnNode.treeInfo.parents = [];
        }
        if (!gnNode.treeInfo.children) {
            gnNode.treeInfo.children = [];
        }
        this.nodes = (gnNode.treeInfo.parents).concat(gnNode.treeInfo.children);
    }
    /**
     * applyChanges method\
     *
     * @returns {  void }    applyChanges method .\
     * @private
     */
    applyChanges() {
        this.graphNode.treeInfo.center = this.location;
    }
}
/**
 * SymmetricalLayout
 */
export class SymmetricLayout {
    constructor() {
        this.cdCOEF = 0.442;
        this.cfMAXVELOCITY = 50;
        this.cnMAXITERACTION = 1000;
        this.cnSPRINGLENGTH = 100;
        this.mszMaxForceVelocity = { width: this.cfMAXVELOCITY, height: this.cfMAXVELOCITY };
        /**
         * @private
         */
        this.springLength = 0;
        /**
         * @private
         */
        this.springFactor = this.cdCOEF;
        /**
         * @private
         */
        this.maxIteration = this.cnMAXITERACTION;
        this.springLength = this.cnSPRINGLENGTH;
    }
    /**
     *To destroy the layout
     *
     * @returns {void} To destroy the layout
     */
    destroy() {
        /**
         * Destroys symmetricLayout
         */
    }
    getModuleName() {
        return 'SymmetricalLayout';
    }
    doGraphLayout(graphLayoutManager) {
        const graph = this.selectedNode;
        graph.treeInfo.Bounds = graphLayoutManager.getModelBounds(graphLayoutManager.nodes);
        const lstGraphNodes = graph.treeInfo.GraphNodes;
        const lstNodes = this.convertGraphNodes(lstGraphNodes);
        let count = lstNodes.length;
        count = Math.min(this.maxIteration, count * count * count);
        this.preLayoutNodes(lstNodes, graph.treeInfo.Bounds);
        for (let i = 0, nLenght = count; i < nLenght; i++) {
            this.makeSymmetricLayout(lstNodes);
            this.appendForces(lstNodes);
        }
        this.resetGraphPosition(lstNodes, graph);
    }
    preLayoutNodes(lstNodes, rcBounds) {
        const fMaxSize = Math.max(rcBounds.width, rcBounds.height);
        const ptCenter = { x: fMaxSize / 2, y: fMaxSize / 2 };
        const dRotateAngle = 2 * Math.PI / lstNodes.length;
        let dAngle = dRotateAngle;
        for (let i = 0; i < lstNodes.length; i++) {
            const gnNode = lstNodes[parseInt(i.toString(), 10)];
            const forceNode = this.getForceNode(gnNode);
            forceNode.location = {
                x: ptCenter.x + fMaxSize * Number((Math.cos(dAngle)).toFixed(2)),
                y: ptCenter.y + fMaxSize * Number(Math.sin(dAngle).toFixed(2))
            };
            dAngle -= dRotateAngle;
        }
    }
    /**
     * doLayout method\
     *
     * @returns {  void }    doLayout method .\
     * @param {GraphLayoutManager} graphLayoutManager - provide the angle value.
     * @private
     */
    doLayout(graphLayoutManager) {
        this.selectedNode = graphLayoutManager.selectedNode;
        this.doGraphLayout(graphLayoutManager);
    }
    makeSymmetricLayout(lstNodes) {
        let forceNode;
        let force;
        for (let k = 0; k < lstNodes.length; k++) {
            const gnNode = lstNodes[parseInt(k.toString(), 10)];
            forceNode = this.getForceNode(gnNode);
            const nodes = forceNode.nodes;
            for (let l = 0; l < nodes.length; l++) {
                const gnChild = nodes[parseInt(l.toString(), 10)];
                this.calcNodesForce(forceNode, this.getForceNode(gnChild));
            }
            for (let i = 0, length = nodes.length; i < length; i++) {
                if (length < 2) {
                    break;
                }
                const vtx1 = this.getForceNode(nodes[parseInt(i.toString(), 10)]);
                const vtx2 = (i + 1 >= length) ? this.getForceNode(nodes[0]) : this.getForceNode((nodes[i + 1]));
                const angle = (360 / nodes.length / 2) * Math.PI / 180;
                const normalDistance = 2 * this.springLength * Math.sin(angle);
                this.calcRelatesForce(vtx1, vtx2, normalDistance);
            }
            for (let s = 0; s < lstNodes.length; s++) {
                const gnChild = lstNodes[parseInt(s.toString(), 10)];
                if (!collectionContains(gnChild.id, nodes) && gnChild.id !== gnNode.id) {
                    force = this.getForceNode(gnChild);
                    this.updateNeigbour(forceNode, force);
                }
            }
        }
    }
    appendForces(lstNodes) {
        let gfnNode = null;
        for (let k = 0; k < lstNodes.length; k++) {
            const gnNode = lstNodes[parseInt(k.toString(), 10)];
            gfnNode = this.getForceNode(gnNode);
            const ptPoint = gfnNode.location;
            ptPoint.x += Math.min(gfnNode.velocityX, this.mszMaxForceVelocity.width);
            ptPoint.y += Math.min(gfnNode.velocityY, this.mszMaxForceVelocity.height);
            gfnNode.velocityX = 0;
            gfnNode.velocityY = 0;
            gfnNode.location = ptPoint;
        }
    }
    resetGraphPosition(lstNodes, graph) {
        const szMin = { width: Number.MAX_VALUE, height: Number.MAX_VALUE };
        let gfnNode = null;
        let gnNode;
        for (let k = 0; k < lstNodes.length; k++) {
            gnNode = lstNodes[parseInt(k.toString(), 10)];
            gfnNode = this.getForceNode(gnNode);
            const ptLocation = {
                x: gfnNode.location.x - gnNode.actualSize.width / 2,
                y: gfnNode.location.y - gnNode.actualSize.height / 2
            };
            szMin.width = Math.min(szMin.width, ptLocation.x);
            szMin.height = Math.min(szMin.height, ptLocation.y);
        }
        for (let k = 0; k < lstNodes.length; k++) {
            gnNode = lstNodes[parseInt(k.toString(), 10)];
            gfnNode = this.getForceNode(gnNode);
            const ptLocation = gfnNode.location;
            ptLocation.x -= szMin.width - (graph.treeInfo.location ? graph.treeInfo.location.x : 0);
            ptLocation.y -= szMin.height - (graph.treeInfo.location ? graph.treeInfo.location.y : 0);
            gfnNode.location = ptLocation;
            gfnNode.applyChanges();
        }
    }
    convertGraphNodes(lstNodes) {
        const lstToReturn = [];
        const keys = Object.keys(lstNodes);
        for (const k of keys) {
            const gnNode = lstNodes[`${k}`];
            const forceNode = new GraphForceNode(gnNode);
            gnNode.treeInfo.tag = forceNode;
            lstToReturn.push(gnNode);
        }
        return lstToReturn;
    }
    /**
     * getForceNode method\
     *
     * @returns {  GraphForceNode }    getForceNode method .\
     * @param {IGraphObject} gnNode - provide the angle value.
     * @private
     */
    getForceNode(gnNode) {
        return gnNode.treeInfo.tag;
    }
    updateNeigbour(vtSource, vtTarget) {
        if (vtTarget == null || vtSource == null) {
            return;
        }
        const distance = this.pointDistance(vtSource.location, vtTarget.location);
        const angle = this.lineAngle(vtSource.location, vtTarget.location);
        const normalDistance = (this.springLength * 0.9);
        if (distance < normalDistance) {
            this.calcForce(distance, normalDistance, angle, vtTarget);
        }
    }
    lineAngle(pt1, pt2) {
        let radians = 0;
        const vx = pt2.x - pt1.x;
        const vy = pt2.y - pt1.y;
        if (vx === 0) {
            if (vy <= 0) {
                radians = (3.0 * Math.PI) / 2.0;
            }
            else {
                radians = Math.PI / 2.0;
            }
        }
        else if (vy === 0) {
            if (vx < 0) {
                radians = Math.PI;
            }
            else {
                radians = 0;
            }
        }
        else {
            radians = Math.atan(vy / vx);
            if (vx < 0 && vy > 0) {
                radians = Math.PI + radians;
            }
            else if (vx < 0 && vy < 0) {
                radians = Math.PI + radians;
            }
            else if (vx > 0 && vy < 0) {
                radians = 2.0 * Math.PI + radians;
            }
        }
        return radians;
    }
    pointDistance(pt1, pt2) {
        let d = 0;
        const dx = pt2.x - pt1.x;
        const dy = pt2.y - pt1.y;
        const t = (dx * dx) + (dy * dy);
        d = Math.sqrt(t);
        return d;
    }
    calcRelatesForce(vtSource, vtTarget, normalDistance) {
        const distance = this.pointDistance(vtSource.location, vtTarget.location);
        const angle = this.lineAngle(vtSource.location, vtTarget.location);
        if (distance < normalDistance) {
            this.calcForce(distance, normalDistance, angle, vtTarget);
        }
    }
    /**
     * @param nodeCollection
     * @param connectors
     * @param symmetricLayout
     * @param nameTable
     * @param layout
     * @param viewPort
     * @private
     */
    /**
     * updateLayout method\
     *
     * @returns {  void }    updateLayout method .\
     * @param {IGraphObject[]} nodeCollection - provide the angle value.
     * @param {IGraphObject[]} connectors - provide the connectors value.
     * @param {SymmetricLayout} symmetricLayout - provide the symmetricLayout value.
     * @param {Object} nameTable - provide the nameTable value.
     * @param {Layout} layout - provide the layout value.
     * @param {PointModel} viewPort - provide the viewPort value.
     * @private
     */
    updateLayout(nodeCollection, connectors, symmetricLayout, nameTable, layout, viewPort) {
        const layoutManager = new GraphLayoutManager();
        layoutManager.updateLayout(nodeCollection, connectors, symmetricLayout, nameTable, layout, viewPort);
    }
    calcNodesForce(vtSource, vtTarget) {
        const distance = this.pointDistance(vtSource.location, vtTarget.location);
        const angle = this.lineAngle(vtSource.location, vtTarget.location);
        if (distance > this.springLength || distance < this.springLength) {
            this.calcForce(distance, this.springLength, angle, vtTarget);
        }
    }
    calcForce(distance, minDist, angle, vtTarget) {
        const count = vtTarget.nodes.length;
        const length = distance - minDist;
        const factor = this.springFactor / (count * count) * Math.sqrt(count);
        const fVelocity = length * factor;
        const fOffset = fVelocity;
        const offsetX = Math.cos(angle) * fOffset;
        const offsetY = Math.sin(angle) * fOffset;
        vtTarget.velocityX -= offsetX;
        vtTarget.velocityY -= offsetY;
    }
}
export class GraphLayoutManager {
    constructor() {
        this.visitedStack = [];
        this.cycleEdgesCollection = [];
        this.graphObjects = [];
        this.passedNodes = [];
    }
    /**
     * @param nodeCollection
     * @param connectors
     * @param symmetricLayout
     * @param nameTable
     * @param layout
     * @param viewPort
     * @private
     */
    /**
     * updateLayout method\
     *
     * @returns {  boolean }    updateLayout method .\
     * @param {IGraphObject[]} nodeCollection - provide the nodeCollection value.
     * @param {IGraphObject[]} connectors - provide the nodeCollection value.
     * @param {SymmetricLayout} symmetricLayout - provide the nodeCollection value.
     * @param {Object} nameTable - provide the nodeCollection value.
     * @param {Layout} layout - provide the nodeCollection value.
     * @param {PointModel} viewPort - provide the nodeCollection value.
     * @private
     */
    updateLayout(nodeCollection, connectors, symmetricLayout, nameTable, layout, viewPort) {
        this.nameTable = nameTable;
        this.nodes = nodeCollection;
        this.connectors = connectors;
        const selectionList = nodeCollection;
        if (selectionList.length > 0) {
            this.mhelperSelectedNode = cloneObject(selectionList[0]);
        }
        for (const node of nodeCollection) {
            const nodeGraphObject = node;
            nodeGraphObject.treeInfo = {};
            nodeGraphObject.treeInfo.graphType = 'Node';
            this.graphObjects.push(nodeGraphObject);
        }
        for (const connector of connectors) {
            const connectorGraphObject = connector;
            connectorGraphObject.treeInfo = {};
            connectorGraphObject.treeInfo.graphType = 'Connector';
            this.graphObjects.push(connectorGraphObject);
        }
        this.updateLayout1(this.graphObjects, symmetricLayout);
        const modelBounds = this.getModelBounds(selectionList);
        for (let i = 0; i < selectionList.length; i++) {
            const node = selectionList[parseInt(i.toString(), 10)];
            const trnsX = (viewPort.x - modelBounds.width) / 2;
            const margin = layout.margin;
            const dx = (node.treeInfo.tag.location.x - (node.offsetX - (node.actualSize.width / 2)) -
                modelBounds.x + trnsX + margin.left);
            const dy = (node.treeInfo.tag.location.y - (node.offsetY - (node.actualSize.height / 2)) - modelBounds.y + margin.top);
            node.offsetX += dx;
            node.offsetY += dy;
            delete node.treeInfo;
        }
        return true;
    }
    /**
     * getModelBounds method\
     *
     * @returns {  Rect }    getModelBounds method .\
     * @param {IGraphObject[]} lNodes - provide the angle value.
     * @private
     */
    getModelBounds(lNodes) {
        lNodes = lNodes.slice();
        let rect = null;
        let rect1 = null;
        let node;
        for (let i = 0; i < lNodes.length; i++) {
            node = lNodes[parseInt(i.toString(), 10)];
            const bounds = getGraphBounds(node);
            rect = new Rect(node.treeInfo.tag ? node.treeInfo.tag.location.x : bounds.x, node.treeInfo.tag ? node.treeInfo.tag.location.y : bounds.y, node.actualSize.width, node.actualSize.height);
            if (rect1) {
                rect1 = rect1.uniteRect(rect);
            }
            else {
                rect1 = rect;
            }
        }
        return rect1;
    }
    updateLayout1(nodesToLayout, symmetricLayout) {
        this.detectCyclesInGraph(nodesToLayout);
        const nodesCount = nodesToLayout.length;
        if (nodesCount > 0) {
            const cycleConnColln = [];
            let nodes = [];
            const nodeSymbols = [];
            for (let s = 0; s < nodesToLayout.length; s++) {
                const nd = nodesToLayout[parseInt(s.toString(), 10)];
                if (nd.treeInfo.isCycleEdge === undefined) {
                    nd.treeInfo.isCycleEdge = false;
                }
                if (nd.treeInfo.graphType === 'Connector' && !nd.treeInfo.isCycleEdge) {
                    nodes.push(nd);
                }
                else if (nd.treeInfo.graphType === 'Connector') {
                    cycleConnColln.push(nd);
                }
                else {
                    nodeSymbols.push(nd);
                }
            }
            nodes = nodes.concat(nodeSymbols);
            nodes = cycleConnColln.concat(nodes);
            while (nodesCount > this.dictionaryLength(this.passedNodes)) {
                this.getNodesToPosition(nodes);
                if (this.selectedNode == null) {
                    continue;
                }
                symmetricLayout.doLayout(this);
                this.selectedNode = null;
                this.visitedStack = [];
            }
            this.passedNodes = null;
            this.selectedNode = null;
        }
        return false;
    }
    getNodesToPosition(nodes) {
        for (let i = 0; i < nodes.length; i++) {
            const node = nodes[parseInt(i.toString(), 10)];
            this.selectNodes(node);
            break;
        }
    }
    selectNodes(node) {
        const nodeGraph = node;
        if (node.treeInfo.graphType === 'Connector') {
            this.exploreGraphEdge(node);
        }
        else if (nodeGraph != null) {
            if (this.addNode(node, 'passed')) {
                this.addNode(node, 'selected');
                if (this.isConnectedToAnotherNode(nodeGraph)) {
                    this.selectedNode = { treeInfo: {} };
                    this.selectedNode.treeInfo.LeftMargin = 10;
                    this.selectedNode.treeInfo.TopMargin = 10;
                    this.selectConnectedNodes(nodeGraph);
                }
            }
        }
    }
    selectConnectedNodes(nodeGraph) {
        const graph = this.selectedNode;
        if (!graph.treeInfo.GraphNodes) {
            graph.treeInfo.GraphNodes = {};
        }
        const node = nodeGraph;
        this.addNode(node, 'passed');
        const nodeName = node.id;
        if (!this.dictionaryContains(graph.treeInfo.GraphNodes, node)) {
            const gnNode = this.addGraphNode(node);
            this.getConnectedRelatives(gnNode);
            this.exploreRelatives(nodeGraph);
        }
        else {
            const graphNode = graph.treeInfo.GraphNodes[`${nodeName}`];
            if (graphNode.treeInfo.Added) {
                graphNode.treeInfo.Added = false;
                this.getConnectedRelatives(graphNode);
                this.exploreRelatives(nodeGraph);
            }
        }
    }
    exploreRelatives(nodeGraph) {
        this.exploreRelatives1(nodeGraph, 'Parents');
        this.exploreRelatives1(nodeGraph, 'Children');
    }
    exploreRelatives1(nodeGraph, relativesToExplore) {
        let edges = [];
        if (relativesToExplore === 'Parents') {
            edges = nodeGraph.inEdges;
        }
        else {
            edges = nodeGraph.outEdges;
        }
        for (let i = 0; i < edges.length; i++) {
            const edge = this.nameTable[edges[parseInt(i.toString(), 10)]];
            if (this.addNode(edge, 'passed')) {
                const fromNode = this.nameTable[edge.sourceID];
                const toNode = this.nameTable[edge.targetID];
                if (relativesToExplore === 'Parents' && fromNode != null &&
                    collectionContains(fromNode.id, this.nodes)) {
                    this.selectConnectedNodes(this.nameTable[edge.sourceID]);
                }
                else if (relativesToExplore === 'Children' && toNode != null &&
                    collectionContains(toNode.id, this.nodes)) {
                    this.selectConnectedNodes(this.nameTable[edge.targetID]);
                }
            }
        }
    }
    getConnectedRelatives(graphNode) {
        this.getConnectedParents(graphNode);
        this.getConnectedChildren(graphNode);
    }
    dictionaryContains(obj, keyObj) {
        const keys = Object.keys(obj);
        for (let i = 0; i < keys.length; i++) {
            if (keys[parseInt(i.toString(), 10)] === keyObj.id) {
                return true;
            }
        }
        return false;
    }
    dictionaryLength(obj) {
        const keys = Object.keys(obj);
        return keys.length;
    }
    getConnectedChildren(graphNode) {
        const graph = this.selectedNode;
        const nodeGraph = graphNode;
        for (let s = 0; s < nodeGraph.outEdges.length; s++) {
            const edge = this.nameTable[nodeGraph.outEdges[parseInt(s.toString(), 10)]];
            if (!edge.treeInfo.isCycleEdge) {
                const node = this.nameTable[edge.targetID];
                if (collectionContains(node.id, this.nodes) && node != null && node.visible) {
                    let gnNodeChildren;
                    if (!this.dictionaryContains(graph.treeInfo.GraphNodes, node)) {
                        gnNodeChildren = this.addGraphNode(node);
                        gnNodeChildren.treeInfo.Added = true;
                    }
                    else {
                        gnNodeChildren = graph.treeInfo.GraphNodes[node.id];
                    }
                    if (!graphNode.treeInfo.children) {
                        graphNode.treeInfo.children = [];
                    }
                    if (!gnNodeChildren.treeInfo.parents) {
                        gnNodeChildren.treeInfo.parents = [];
                    }
                    this.setNode(gnNodeChildren.treeInfo.parents, graphNode);
                    if (this.findNode(graphNode.treeInfo.children, gnNodeChildren.id) < 0) {
                        graphNode.treeInfo.children.push(gnNodeChildren);
                    }
                }
            }
        }
    }
    getConnectedParents(graphNode) {
        const graph = this.selectedNode;
        const nodeGraph = graphNode;
        for (let s = 0; s < nodeGraph.inEdges.length; s++) {
            const edge = this.nameTable[nodeGraph.inEdges[parseInt(s.toString(), 10)]];
            if (!edge.treeInfo.isCycleEdge) {
                const node = this.nameTable[edge.sourceID];
                if (collectionContains(node.id, this.nodes) && node != null && node.visible) {
                    let gnNode;
                    if (!this.dictionaryContains(graph.treeInfo.GraphNodes, node)) {
                        gnNode = this.addGraphNode(node);
                        gnNode.treeInfo.Added = true;
                    }
                    else {
                        gnNode = graph.treeInfo.GraphNodes[node.id];
                    }
                    if (!graphNode.treeInfo.parents) {
                        graphNode.treeInfo.parents = [];
                    }
                    if (!gnNode.treeInfo.children) {
                        gnNode.treeInfo.children = [];
                    }
                    this.setNode(gnNode.treeInfo.children, graphNode);
                    if (this.findNode(graphNode.treeInfo.parents, gnNode.id) < 0) {
                        graphNode.treeInfo.parents.push(gnNode);
                    }
                }
            }
        }
    }
    setNode(list, node) {
        const nIndex = this.findNode(list, node.id);
        if (nIndex >= 0 && nIndex < list.length) {
            list[parseInt(nIndex.toString(), 10)] = node;
        }
        else {
            list.push(node);
        }
    }
    findNode(list, fullName) {
        let nIndex = -1;
        if (list != null && fullName !== '') {
            for (let i = 0, nLength = list.length; i < nLength; i++) {
                const gnNode = list[parseInt(i.toString(), 10)];
                if (gnNode != null && gnNode.id === fullName) {
                    nIndex = i;
                    break;
                }
            }
        }
        return nIndex;
    }
    addGraphNode(node) {
        const graph = this.selectedNode;
        const gnNode = node;
        graph.treeInfo.GraphNodes[gnNode.id] = gnNode;
        const nodeHelper = this.mhelperSelectedNode;
        if (nodeHelper != null && node.id === nodeHelper.id) {
            this.mhelperSelectedNode = gnNode;
        }
        return gnNode;
    }
    isConnectedToAnotherNode(gnNode) {
        let bFoundConnectedNode = false;
        const edges = (gnNode.inEdges).concat(gnNode.outEdges);
        if (edges.length > 0) {
            if ((gnNode.inEdges != null) && (gnNode.inEdges.length > 0)) {
                bFoundConnectedNode = this.searchEdgeCollection(gnNode.inEdges, 'FromNode');
            }
            if ((!bFoundConnectedNode) && (gnNode.outEdges != null) && (gnNode.outEdges.length > 0)) {
                bFoundConnectedNode = this.searchEdgeCollection(gnNode.outEdges, 'ToNode');
            }
        }
        return bFoundConnectedNode;
    }
    searchEdgeCollection(edgesToSearchThrough, connectionDirection) {
        let bFoundConnectedNode = false;
        for (let i = 0; i < edgesToSearchThrough.length - 1; i++) {
            const edge = this.nameTable[edgesToSearchThrough[parseInt(i.toString(), 10)]];
            if (!this.addNode(edge, 'passed')) {
                continue;
            }
            if (!edge.treeInfo.isCycleEdge && ((connectionDirection === 'FromNode' && this.nameTable[edge.sourceID] != null)
                || (connectionDirection === 'ToNode' && this.nameTable[edge.targetID] != null))) {
                bFoundConnectedNode = true;
                break;
            }
        }
        return bFoundConnectedNode;
    }
    exploreGraphEdge(node) {
        const nodeLink = node;
        if (nodeLink != null && !nodeLink.treeInfo.isCycleEdge && this.addNode(node, 'passed')) {
            this.addNode(node, 'selected');
            const fromNode = this.nameTable[nodeLink.sourceID];
            const toNode = this.nameTable[nodeLink.targetID];
            if (fromNode != null) {
                this.selectNodes(fromNode);
            }
        }
    }
    addNode(nodeToAdd, collectionToAdd) {
        const bResult = true;
        const node = nodeToAdd;
        if (collectionToAdd === 'passed' || !node.visible) {
            if (!this.dictionaryContains(this.passedNodes, node)) {
                this.passedNodes[node.id] = node;
            }
        }
        if (!node.visible) {
            return false;
        }
        return bResult;
    }
    detectCyclesInGraph(nodes) {
        const vertex = [];
        const currentStack = [];
        for (let k = 0; k < nodes.length; k++) {
            if (!(nodes[parseInt(k.toString(), 10)].treeInfo.graphType === 'Connector')) {
                vertex.push(nodes[parseInt(k.toString(), 10)]);
            }
        }
        if (vertex.length > 0) {
            currentStack.push(vertex[0]);
            this.visitedStack.push(vertex[0]);
            while (currentStack.length > 0) {
                const top = currentStack[currentStack.length - 1];
                const childNodes = this.getUnVisitedChildNodes(top);
                if (childNodes.length > 0) {
                    const child = childNodes[0];
                    const currentEdge = childNodes[childNodes.length - 1];
                    if (collectionContains(child.id, this.visitedStack)) {
                        currentEdge.treeInfo.isCycleEdge = true;
                        this.cycleEdgesCollection.push(currentEdge);
                    }
                    else {
                        currentStack.push(child);
                        this.visitedStack.splice(0, 0, child);
                    }
                }
                else {
                    currentStack.pop();
                }
            }
        }
    }
    getUnVisitedChildNodes(top) {
        const childNodes = [];
        if (top.outEdges.length > 0) {
            for (let i = 0; i < top.outEdges.length; i++) {
                const con = this.nameTable[top.outEdges[parseInt(i.toString(), 10)]];
                if (!collectionContains(con.id, this.visitedStack)) {
                    const toNode = this.nameTable[con.targetID];
                    if (toNode != null) {
                        childNodes.push(toNode);
                    }
                    childNodes.push(con);
                    this.visitedStack.splice(0, 0, con);
                    return childNodes;
                }
            }
            return childNodes;
        }
        return childNodes;
    }
}
/**
 * getGraphBounds method\
 *
 * @returns {  void }    getGraphBounds method .\
 * @param {IGraphObject} node - provide the angle value.
 * @private
 */
function getGraphBounds(node) {
    const x = node.offsetX - node.actualSize.width * node.pivot.x;
    const y = node.offsetY - node.actualSize.height * node.pivot.y;
    return new Rect(x, y, node.actualSize.width, node.actualSize.height);
}
/**
 * @param id
 * @param coll
 */
/**
 * collectionContains method\
 *
 * @returns {  boolean }    collectionContains method .\
 * @param {string} id - provide the id value.
 * @param {IGraphObject[]} coll - provide the id value.
 * @private
 */
function collectionContains(id, coll) {
    for (let i = 0; i < coll.length; i++) {
        if (coll[parseInt(i.toString(), 10)].id === id) {
            return true;
        }
    }
    return false;
}
